export function getTenantData() {
    let values = {
        "7080010002488": {
            "agreement_terms":"https://klarkraft.no/avtalevilkår",
            "withdrawal_rights":""
        },
        "7080003965332": {
            "agreement_terms":"https://www.helgelandkraft.no/strom/privat/vilkar/",
            "withdrawal_rights":"https://www.helgelandkraft.no/globalassets/angreskjema.pdf"
        }
    };

    return values[localStorage.tenant];
}